// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".version {\n  font-size: 10px;\n  font-weight: 700;\n}", ""]);
// Exports
module.exports = exports;
